export default [{ label: 'Columns', value: 'columns' }, { label: 'Rows', value: 'rows' }];



// WEBPACK FOOTER //
// ./src/constants/formatTypes.js